import { produce } from "immer";
import {
  SHOW_SNACKBAR_SUCCESS,
  HIDE_SNACKBAR_SUCCESS,
} from "../events/snackbarEvents";

const initialState = {
  open: false,
  message: "",
  severity: "error",
};

export default function snackbarReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_SNACKBAR_SUCCESS:
      return produce(state, (draft) => {
        draft.open = true;
        draft.message = action.payload.message;
        draft.severity = action.payload.severity;
      });
    case HIDE_SNACKBAR_SUCCESS:
      return produce(state, (draft) => {
        draft.open = false;
        draft.message = "";
      });
    default:
      return state;
  }
}
